import { api } from "@/lib/api";
import type { PstnCallParams } from "./types";

export async function makePstnCall(params: PstnCallParams): Promise<void> {
	await api.get("/leads/calls/pstn_call", { params });
}
